import {
  USER_PROFILE_ALLOCATIONS,
  ADVISOR_PROFILE_FIELD_PREFIX,
  COMPUTED_ALLOCATION_ACCOUNTS_PREFIX,
  STATE_VALUE_WILDCARD_SUFFIX,
  INVESTOR_PROFILE_FIELD_PREFIX,
  INVESTOR_BANK_ACCOUNT_FIELD_IDS,
  USER_PROFILE_FIELD_PREFIX,
  ACCOUNT_FIELD_PREFIX,
  SOURCE_ACCOUNT_FIELD_PREFIX,
  META_FIELD_PREFIX,
} from '@/constants/engine';
import {DOMAIN_VALUE_REFERENCE_REGEX, DOMAIN_VALUE_LIST_REFERENCE_REGEX} from '@/model/schema/reference';
import {DOMAIN_VALUE_BOOLEAN, DOMAIN_VALUE_PREFIX} from '@/model/types/constants';

export const getReferenceType = (ref: string): 'domainValueList' | 'domainValue' | 'state' | 'stateQuery' => {
  if (ref.startsWith(DOMAIN_VALUE_PREFIX)) {
    if (ref.startsWith(DOMAIN_VALUE_BOOLEAN)) return 'domainValue';
    if (DOMAIN_VALUE_REFERENCE_REGEX.test(ref)) return 'domainValue';
    if (DOMAIN_VALUE_LIST_REFERENCE_REGEX.test(ref)) return 'domainValueList';
    throw new Error(`Unknown domain value reference syntax: ${ref}`);
  }

  if (ref.endsWith(STATE_VALUE_WILDCARD_SUFFIX)) {
    return 'stateQuery';
  }
  return 'state';
};

export const isFieldVisible = (field: string, visibilitySet?: Set<string>): boolean => {
  if (!visibilitySet) return true;

  // If the field is meta value beginning with "_", check if the array/group is visible instead
  if (field.startsWith(META_FIELD_PREFIX) && field.includes('[')) {
    return visibilitySet.has(field.slice(1, field.length - 1).split('[')[0]);
  }

  return visibilitySet.has(field);
};

export const isReferenceToUserProfile = (ref: string): boolean =>
  ref.startsWith(USER_PROFILE_FIELD_PREFIX.toUpperCase()) || ref.startsWith(USER_PROFILE_ALLOCATIONS);

export const isReferenceToAdvisorProfile = (ref: string): boolean =>
  ref.startsWith(ADVISOR_PROFILE_FIELD_PREFIX.toUpperCase()) || ref.startsWith(USER_PROFILE_ALLOCATIONS);

export const isReferenceToInvestorProfile = (ref: string): boolean =>
  ref.startsWith(INVESTOR_PROFILE_FIELD_PREFIX.toUpperCase());

export const isReferenceToInvestorBankAccount = (ref: string): boolean =>
  INVESTOR_BANK_ACCOUNT_FIELD_IDS.some(fieldId => ref === fieldId || ref.startsWith(`${fieldId}#`));

export const isReferenceToAccount = (ref: string): boolean => ref.startsWith(ACCOUNT_FIELD_PREFIX.toUpperCase());

export const isReferenceToAccountMeta = (ref: string): boolean =>
  ref.startsWith(`${META_FIELD_PREFIX}${ACCOUNT_FIELD_PREFIX.toUpperCase()}`);

export const isReferenceToSourceAccount = (ref: string): boolean =>
  ref.startsWith(SOURCE_ACCOUNT_FIELD_PREFIX.toUpperCase());

export const isReferenceToSourceAccountMeta = (ref: string): boolean =>
  ref.startsWith(`${META_FIELD_PREFIX}${SOURCE_ACCOUNT_FIELD_PREFIX.toUpperCase()}`);

export const isReferenceToComputedAllocationAccount = (ref: string): boolean =>
  ref.startsWith(COMPUTED_ALLOCATION_ACCOUNTS_PREFIX);

export const isReferenceAlwaysVisible = (ref: string): boolean =>
  isReferenceToUserProfile(ref) ||
  isReferenceToAdvisorProfile(ref) ||
  isReferenceToInvestorProfile(ref) ||
  isReferenceToAccount(ref) ||
  isReferenceToAccountMeta(ref) ||
  isReferenceToSourceAccount(ref) ||
  isReferenceToSourceAccountMeta(ref) ||
  isReferenceToComputedAllocationAccount(ref);
